<template>
    <div id="LiveLesson">
        <el-tabs
            v-model="activeName"
            v-if="activeName !== 'classTime'"
            @tab-click="handleClick"
        >
            <el-tab-pane label="已审直播" name="okAudit">
                <Select
                    :isShow.sync="isShow"
                    :tableName="tableName"
                    @selectFn="selectFn"
                ></Select>
                <div class="selectbtn">
                    <button @click="isShow = true" style="cursor: pointer">
                        筛选
                    </button>
                    <button
                        @click="activeName = 'addAudit'"
                        v-show="!isPartner"
                        style="cursor: pointer"
                    >
                        添加直播课程
                    </button>
                    <button
                        v-show="!isPartner"
                        @click="DisablesClass"
                        style="cursor: pointer"
                    >
                        禁用课程
                    </button>
                </div>
                <Table
                    ref="okAudit"
                    :tableData="livetableData"
                    :activeName.sync="activeName"
                    @toClassTime="toClassTime(arguments)"
                    @toEdit="toEditFn(arguments)"
                    @successDisablesClass="handleClick"
                ></Table>
                <Pagination
                    :total="livetableData.length"
                    @pagination="pagination"
                ></Pagination>
            </el-tab-pane>
            <el-tab-pane label="待审直播" name="waitAudit">
                <Select
                    :isShow.sync="isShow"
                    :tableName="tableName"
                    @selectFn="selectFn"
                ></Select>
                <div class="selectbtn">
                    <button @click="isShow = true" style="cursor: pointer">
                        筛选
                    </button>
                    <button
                        @click="activeName = 'addAudit'"
                        style="cursor: pointer"
                    >
                        添加直播课程
                    </button>
                    <button style="cursor: pointer">审核通过</button>
                    <button style="cursor: pointer">审核退回</button>
                </div>
                <Table
                    ref="waitAudit"
                    :tableData="waittableData"
                    :activeName.sync="activeName"
                    @toClassTime="toClassTime(arguments)"
                    @toEdit="toEditFn(arguments)"
                    @successDisablesClass="handleClick"
                ></Table>
                <Pagination
                    :total="waittableData.length"
                    @pagination="pagination"
                ></Pagination>
            </el-tab-pane>
            <el-tab-pane label="回收站" name="delAudit" v-if="!isPartner">
                <Select
                    :isShow.sync="isShow"
                    :tableName="tableName"
                    @selectFn="selectFn"
                ></Select>
                <div class="selectbtn">
                    <button @click="DisablesClass" style="cursor: pointer">
                        彻底删除
                    </button>
                </div>
                <Table
                    ref="delAudit"
                    :tableData="deltableData"
                    :activeName.sync="activeName"
                    @toClassTime="toClassTime(arguments)"
                    @toEdit="toEditFn(arguments)"
                ></Table>
                <Pagination
                    :total="deltableData.length"
                    @pagination="pagination"
                ></Pagination>
            </el-tab-pane>
            <el-tab-pane
                label="添加课程"
                name="addAudit"
                v-if="activeName === 'addAudit'"
            >
                <Details
                    @backFn="backFn"
                    @addLineClass="addLineClass"
                ></Details>
            </el-tab-pane>
            <el-tab-pane
                label="编辑课程"
                name="editAudit"
                v-if="activeName === 'editAudit'"
            >
                <Details
                    :courseId="course.id"
                    @backFn="backFn"
                    @addLineClass="addLineClass"
                ></Details>
            </el-tab-pane>
        </el-tabs>
        <!-- 课时管理 -->
        <div v-else>
            <div style="position: relative">
                <h3>{{ course.course_name }}</h3>
                <button
                    @click="backButtonFn"
                    class="back"
                    style="cursor: pointer"
                >
                    返回
                </button>
            </div>
            <el-tabs v-model="activeName">
                <el-tab-pane label="课时管理" name="classTime">
                    <Select
                        :isShow.sync="isShow"
                        :tableName="tableName"
                        :courseId="course.course_id"
                        @selectFn="selectFn"
                    ></Select>
                    <div class="selectbtn">
                        <button @click="isShow = true">筛选</button>
                        <button v-show="!isPartner" @click="exportFn">
                            {{
                                tableName === "classTime"
                                    ? "添加"
                                    : "导出筛选结果"
                            }}
                        </button>
                        <button
                            @click="tableName = 'classTime'"
                            class="backClassTime"
                            style="cursor: pointer"
                            v-if="
                                tableName === 'student' ||
                                tableName === 'attendance'
                            "
                        >
                            返回课时管理
                        </button>
                    </div>
                    <ClassTimeTable
                        v-if="tableName === 'classTime'"
                        :courseId="course.id"
                        :tableName.sync="tableName"
                        :selectTableData="tableData"
                        :page="page"
                        @total="totalFn"
                        @toAttendance="toAttendanceFn(arguments)"
                        @toStudent="toStudentFn(arguments)"
                    ></ClassTimeTable>
                    <StudentTable
                        ref="student"
                        v-if="tableName === 'student'"
                        :courseId="course.course_id"
                        :selectTableData="tableData"
                        :page="page"
                        @total="totalFn"
                    ></StudentTable>
                    <AttendanceTable
                        ref="attendance"
                        v-if="tableName === 'attendance'"
                        :courseId="course.course_id"
                        :selectTableData="tableData"
                        :page="page"
                        @total="totalFn"
                    ></AttendanceTable>
                    <MyDialog
                        :course="{ id: 85 }"
                        :videoId="course.course_id"
                        :dialogFormVisible="dialogFormVisible"
                        :dialogType="dialogType"
                    ></MyDialog>
                    <Pagination
                        :total="total"
                        @pagination="pagination"
                    ></Pagination>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import MyDialog from "./component/MyDialog.vue";
import Select from "./component/Select.vue";
import Table from "./component/Table.vue";
import ClassTimeTable from "./component/ClassTimeTable.vue";
import StudentTable from "./component/studentTable.vue";
import AttendanceTable from "./component/attendanceTable.vue";
import Details from "./component/Details.vue";
import Pagination from "./component/pagination.vue";
import {
    getLiveTableList,
    getWaitTableList,
    getDelTableList,
    DisablesClass,
} from "@/api/LiveLesson/index.js";
import {
    exportStudentList,
    exportSignList,
} from "@/api/LiveLesson/classTimeapi.js";
export default {
    data() {
        return {
            // tabs栏切换
            activeName: "okAudit",
            // 筛选功能切换
            tableName: "",
            // 上一次tabs栏
            oldactiveName: "okAudit",
            // 筛选功能显示
            isShow: false,
            // 需要跳转的课程信息
            course: "",
            // 用户是否可操作
            isPartner: this.$route.query.isPartner,
            // 弹窗显示
            dialogFormVisible: false,
            // 弹窗类型
            dialogType: "add",
            // 筛选出来的数据
            tableData: [],
            livetableData: [],
            waittableData: [],
            deltableData: [],
            // 分页
            page: {
                // 当前
                page: 1,
                // 每页显示条目个数
                pageSize: 20,
            },
            total: "",
        };
    },
    components: {
        Select,
        Table,
        Details,
        ClassTimeTable,
        StudentTable,
        AttendanceTable,
        MyDialog,
        Pagination,
    },
    methods: {
        // 标签页切换
        async handleClick() {
            if (this.activeName === "okAudit") {
                let res = await getLiveTableList();
                res = JSON.parse(JSON.stringify(res));
                this.livetableData = res.data.data.data || [];
            }
            if (this.activeName === "waitAudit") {
                let res1 = await getWaitTableList();
                res1 = JSON.parse(JSON.stringify(res1));
                this.waittableData = res1.data.data.data || [];
            }
            if (this.activeName === "delAudit") {
                let res2 = await getDelTableList();
                res2 = JSON.parse(JSON.stringify(res2)) || [];
                this.deltableData = res2.data.data.data;
            }
            // this.livetableData = [
            //     {
            //         apply_type: "0",
            //         course_id: "83",
            //         course_name: "杨幂",
            //         course_order_count: "4",
            //         course_price: "0.01",
            //         cover_img: "data/upload/2021/1014/17/6167f79eb6518.jpg",
            //         is_overt: "0",
            //         name: "杨幂",
            //         title: "广东工业大学",
            //     },
            // ];
        },
        // 跳转课时管理页面
        toClassTime(msg) {
            this.oldactiveName = msg[0];
            this.course = msg[1];
            this.activeName = msg[2];
        },
        // 跳转课时管理学生
        toStudentFn(msg) {
            this.course = msg[0];
            this.tableName = msg[1];
        },
        // 跳转课时管理考勤
        toAttendanceFn(msg) {
            this.course = msg[0];
            this.tableName = msg[1];
        },
        // 返回按钮，退出课时管理
        backButtonFn() {
            this.activeName = this.oldactiveName;
            this.tableName = "";
        },
        // 修改完成
        toEditFn(msg) {
            this.course = msg[0];
            this.activeName = msg[1];
        },
        // 添加编辑返回
        backFn() {
            this.activeName = this.oldactiveName;
        },
        // 添加或者导出
        exportFn() {
            // 添加
            if (this.tableName === "classTime") {
                this.dialogType = "add";
                this.dialogFormVisible = true;
            }
            // 导出
            if (this.tableName === "student") {
                let ids;
                if (this.$refs.student.multipleSelection) {
                    ids = this.$refs.student.multipleSelection.map(
                        (item) => item.ID
                    );
                }
                if (ids.length == 0) {
                    return this.$message({
                        message: "还未选择需要导出的文件",
                        type: "warning",
                    });
                }
                let id = [...new Set(ids)].join();
                exportStudentList({
                    teacherCourseBatchId: this.course.course_id,
                    teacherCourseUIDs: id,
                });
            }
            if (this.tableName === "attendance") {
                let ids;
                if (this.$refs.attendance.multipleSelection) {
                    ids = this.$refs.attendance.multipleSelection.map(
                        (item) => item.ID
                    );
                }
                if (ids.length == 0) {
                    return this.$message({
                        message: "还未选择需要导出的文件",
                        type: "warning",
                    });
                }
                let id = [...new Set(ids)].join();
                exportSignList({
                    teacherCourseBatchId: this.course.course_id,
                    teacherCourseUIDs: id,
                });
            }
        },
        // 禁用请求
        DisablesClass() {
            let ids;
            if (this.activeName === "okAudit") {
                ids = this.$refs.okAudit.multipleSelection;
            } else if (this.activeName === "waitAudit") {
                ids = this.$refs.waitAudit.multipleSelection;
            } else {
                ids = this.$refs.delAudit.multipleSelection;
            }
            if (ids.length <= 0) {
                return this.$message("还未选择禁用课程");
            }

            if (this.activeName !== "delAudit") {
                this.$confirm("此操作将禁用该课程, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        DisablesClass({
                            ids,
                            status: 1,
                        });
                        this.$message({
                            type: "success",
                            message: "禁用成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消禁用",
                        });
                    });
            } else {
                this.$confirm("此操作将彻底删除该课程, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        DisablesClass({
                            ids,
                            status: 2,
                        });
                        this.$message({
                            type: "success",
                            message: "彻底删除成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消启用",
                        });
                    });
            }
        },
        // 筛选结果
        selectFn(table) {
            this.tableData = table;
            if (this.activeName === "okAudit") {
                this.livetableData = table;
            }
            if (this.activeName === "waitAudit") {
                this.waittableData = table;
            }
            if (this.activeName === "delAudit") {
                this.deltableData = table;
            }
            this.isShow = false;
        },
        // 分页
        async pagination(val) {
            // 发请求
            if (this.activeName === "okAudit") {
                let res = await getLiveTableList({
                    p: val.page,
                    limit: val.pageSize,
                });
                res = JSON.parse(JSON.stringify(res));
                this.livetableData = res.data.data.data || [];
                return;
            }
            if (this.activeName === "waitAudit") {
                let res1 = await getWaitTableList({
                    p: val.page,
                    limit: val.pageSize,
                });
                res1 = JSON.parse(JSON.stringify(res1));
                this.waittableData = res1.data.data.data || [];
                return;
            }
            if (this.activeName === "delAudit") {
                let res2 = await getDelTableList({
                    p: val.page,
                    limit: val.pageSize,
                });
                res2 = JSON.parse(JSON.stringify(res2)) || [];
                this.deltableData = res2.data.data.data;
                return;
            }
            this.page = val;
        },
        totalFn(val) {
            this.total = val;
        },
        // 编辑保存
        addLineClass() {
            this.activeName = this.oldactiveName;
            this.handleClick();
        },
    },
    created() {
        this.handleClick();
    },
    watch: {
        activeName: function () {
            if (this.activeName === "classTime") {
                this.tableName = this.activeName;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#LiveLesson {
    padding: 15px;
}
.selectbtn {
    width: 100%;
    height: 55px;
    line-height: 65px;
    margin: 10px 0;
    background-color: #f2f2f2;
    position: relative;
}
button {
    // width: 73px;
    height: 28px;
    border-radius: 5px;
    margin: 0 20px;
    padding: 0 20px;
    background-color: #409eff;
    border: 0;
    color: #fff;
}
.back {
    position: absolute;
    bottom: -30px;
    right: 0;
    width: 97px;
    height: 28px;
    background-color: rgba(215, 215, 215, 1);
    border: none;
    border-radius: 5px;
    z-index: 99;
}
.backClassTime {
    position: absolute;
    top: 15px;
    right: 0;
    width: 120px;
    height: 28px;
    background-color: rgba(215, 215, 215, 1);
    border: none;
    border-radius: 5px;
    z-index: 99;
}
</style>